import Guide from '@/containers/guide/Guide';

import { ROUTE_GUIDE } from '@/router/names';

export default [
    {
        path: '/guide',
        name: ROUTE_GUIDE,
        component: Guide,
        meta: {
            title: '欢迎加入私教约课系统',
        },
    },
];



// WEBPACK FOOTER //
// ./src/router/guide.js